import React from 'react';
import PreFormGeneric from '../../../../../common/PreFormGeneric';
import { useLocation } from 'react-router-dom';

const PreFormChangeDateMobile = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const motiveId = params.get('motiveId');

  return (
    <PreFormGeneric mobile motiveId={motiveId} issueFormName={'ChangeDate'} />
  );
};

export default PreFormChangeDateMobile;
